import React from 'react';
import {Col, Row} from 'react-bootstrap';
import CardComponent from '../../../app/common/components/CardComponent';
import Reclamation from './Reclamation';
import {useIntl} from 'react-intl';
// import DocumentRequestManager from './DocumentRequestManager';

const TicketFormGrid = () => {
    const intl = useIntl();

    return (
        <Row>
            <Col xs={12} md={10} lg={11} xl={8}>
                <CardComponent title={intl.formatMessage({id: 'ADMINISTRATIVE.RECLAMATIONS'})}>
                    <Reclamation />
                </CardComponent>
            </Col>
            {/* <Col>
                <CardComponent title={intl.formatMessage({id: 'ADMINISTRATIVE.DOCUMENTS'})}>
                    <DocumentRequestManager />
                </CardComponent>
            </Col> */}
        </Row>
    );
};

export default TicketFormGrid;
